"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOT2Label = exports.getOT1Label = exports.getBaseOTLabel = void 0;
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const BASE_LABELS = {
    w2: {
        full: 'overtime',
        abbreviate: 'OT',
    },
    ten99: {
        full: 'extended rate',
        abbreviate: 'XR',
    },
};
const getBaseOTLabel = ({ isW2, abbreviate, capitalize = true }) => {
    const lowerCaseLabel = BASE_LABELS[isW2 ? 'w2' : 'ten99'][abbreviate ? 'abbreviate' : 'full'];
    const shouldCapitalize = capitalize && !abbreviate;
    return shouldCapitalize ? (0, capitalize_1.default)(lowerCaseLabel) : lowerCaseLabel;
};
exports.getBaseOTLabel = getBaseOTLabel;
const getOT1Label = (options) => {
    const { abbreviate } = options;
    const baseLabel = (0, exports.getBaseOTLabel)(options);
    return `${baseLabel}${abbreviate ? '' : ' '}1`;
};
exports.getOT1Label = getOT1Label;
const getOT2Label = (options) => {
    const { abbreviate } = options;
    const baseLabel = (0, exports.getBaseOTLabel)(options);
    return `${baseLabel}${abbreviate ? '' : ' '}2`;
};
exports.getOT2Label = getOT2Label;
